'use es6';

import * as publicTrackerClient from 'usage-tracker-public';
import CommonTrackerProperties from 'pricing-pages-unified-ui/utils/CommonTrackerProperties';
export default (() => {
  return publicTrackerClient.createTracker(Object.assign({}, CommonTrackerProperties, {
    isExternalHost: false
  }));
});